import React, { useState, useContext, useEffect } from "react"
import { Link, PageProps, graphql } from "gatsby"
import Layout from "../components/layout/layout"
import PopularArticle from "../components/popularArticle/popularArticle"
import SEO from "../components/seo"
import ArticleProvider from "../providers/article/article.provider"
import ArticlePreview from "../components/articlePreview/articlePreview"
import About from "../components/about/about"
import styled from "styled-components"
import axios from "axios"
import { device } from "../components/mediaQuery/mediaQuery"
import useViewCount from "../components/useViewCount"

const IndexPage: React.FC<PageProps> = ({ pageContext }) => {
  const { articleDatas } = pageContext

  const articles = useViewCount(articleDatas)

  return (
    <ArticleProvider articleDatas={articles}>
      <Layout>
        <SEO title="Home" />
        <PopularArticle />
        <StyledArticlePreview />
        <About to={`/about`} title={`About`} hasReadMore />
      </Layout>
    </ArticleProvider>
  )
}

const StyledArticlePreview = styled(ArticlePreview)`
  @media ${device.tablet} {
    display: none;
  }
  @media ${device.desktop} {
  }
`

export default IndexPage
